<div class="container-fluid">
  <div class="row mt-2 mb-4">
    <div class="col-md-12 mb-4">
      <nb-icon icon="arrow-back-outline" class="back-icon"></nb-icon>
      <a routerLink="/dashboard" class="link-text ml-1">Dashboard</a>
    </div>
  </div>

  <div class="row mb-4" [nbSpinner]="processing" nbSpinnerStatus="primary" nbSpinnerSize="giant">
    <div class="col-md-12 title-text center" style="font-size:22px">Annual Accounting Report</div>
  </div>

  <div class="row mb-3">
    <div class="col-md-3 mb-3">
      <label class="label-text" for="startDate">START DATE</label>
      <input id="startDate" name="startDate" nbInput fullWidth type="date" [(ngModel)]="startDate">
    </div>
    <div class="col-md-3 mb-3">
      <label class="label-text" for="endDate">END DATE</label>
      <input id="endDate" name="endDate" nbInput fullWidth type="date" [(ngModel)]="endDate">
    </div>
    <div class="col-md-3 mb-3">
      <label class="label-text" for="bankAccountType">BANK ACCOUNT</label>
      <nb-select id="bankAccountType" name="bankAccountType" fullWidth placeholder="All bank accounts" [(selected)]="bankAccountType">
        <nb-option [value]="null">All bank accounts</nb-option>
        <nb-option *ngFor="let type of bankAccountTypes" [value]="type">{{ type }}</nb-option>
      </nb-select>
    </div>
    <div class="col-md-3 mb-3">
      <label class="label-text" for="auctionTypes">AUCTION TYPES</label>
      <nb-select id="auctionTypes" name="auctionTypes" fullWidth multiple placeholder="All auction types" [(selected)]="auctionTypes">
        <nb-option *ngFor="let type of auctionTypeOptions" [value]="type">{{ type }}</nb-option>
      </nb-select>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-md-12">
      <button nbButton status="primary" [disabled]="!hasValidDateRange() || processing" (click)="generateReport()">GENERATE REPORT</button>
      <button class="ml-2" nbButton status="basic" [disabled]="!canExport()" (click)="exportCsv()">EXPORT CSV</button>
    </div>
  </div>

  <div class="row mb-3" *ngIf="errorMsg">
    <div class="col-md-12"><span class="errorText">{{ errorMsg }}</span></div>
  </div>

  <div class="row mb-3" *ngIf="report && report.omittedAuctionCount > 0">
    <div class="col-md-12 omitted-warning">
      {{ report.omittedAuctionCount }} auction(s) were omitted.
      <span *ngFor="let omitted of report.omissionReasons; let last = last">{{ omitted.reason }} ({{ omitted.count }}){{ last ? '' : '; ' }}</span>
    </div>
  </div>

  <div class="row" *ngIf="report">
    <div class="col-md-12 table-responsive">
      <table class="table report-table">
        <thead>
          <tr><th>Auction ID</th><th>Auction Date</th><th>Auction Title</th><th>Auction Type</th><th>Bank Account</th><th>Lots</th><th>Sold Lots</th><th>Gross Sales</th><th>AR Outstanding</th><th>Selling Expenses</th><th>Auction Payables</th><th>Sales Mgmt. Commission</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of report.rows">
            <td><a *ngIf="row.auctionId" class="link-text" [routerLink]="auctionDetailLink(row.auctionId)">{{ row.auctionId }}</a></td>
            <td>{{ formatAuctionDate(row.auctionStartDate) }}</td><td>{{ row.title }}</td><td>{{ row.auctionType }}</td><td>{{ row.bankAccountType }}</td>
            <td>{{ formatCount(row.lotCount) }}</td><td>{{ formatCount(row.soldLotCount) }}</td>
            <td>{{ formatAmount(row.grossSales) }}</td><td>{{ formatAmount(row.accountsReceivableOutstanding) }}</td><td>{{ formatAmount(row.sellingExpenses) }}</td><td>{{ formatAmount(row.auctionPayables) }}</td><td>{{ formatAmount(row.salesManagementCommission) }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr><th>Totals</th><td colspan="4"></td><th>{{ formatCount(report.totals.lotCount) }}</th><th>{{ formatCount(report.totals.soldLotCount) }}</th><th>{{ formatTotalAmount(report.totals.grossSales) }}</th><th>{{ formatTotalAmount(report.totals.accountsReceivableOutstanding) }}</th><th>{{ formatTotalAmount(report.totals.sellingExpenses) }}</th><th>{{ formatTotalAmount(report.totals.auctionPayables) }}</th><th>{{ formatTotalAmount(report.totals.salesManagementCommission) }}</th></tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>
